import { useState } from "react"
import { ResourceDetailsDialogParams } from "../../../../dialogs/resourceDetailsDialog/ResourceDetailsDialog"

export const useResourceDetailsDialog = () => {
    const [resourceDetails, setResource] = useState<ResourceDetailsDialogParams | null>(null)

    const openResourceDetailsDialog = (res: ResourceDetailsDialogParams) => setResource(res)
    const closeResourceDetailsDialog = () => setResource(null)

    return { resourceDetails, openResourceDetailsDialog, closeResourceDetailsDialog }
}
